import React, {Component} from 'react';
import LoginFormContainer from "../../containers/forms/LoginFormContainer";
import packageJson from '../../../package.json';
import { translate } from 'react-i18next';

import fusionLogo from '../../gfx/fusion.png';
import {connect} from "react-redux";

class LoginPage extends Component {
    render() {
        const { t, scope } = this.props;
        return (
            <div className="middle-box text-center loginscreen">
                <div>
                    <img src={fusionLogo} alt={t('title')}/>
                    <h3 className="m-t">
                        {scope.small ? scope.small.backendName : ''}
                    </h3>
                    <p>
                        {t('login.subtitle', { version: packageJson.version })}
                    </p>
                    <LoginFormContainer/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    scope: state.scope
});

export default connect(mapStateToProps, {})(translate()(LoginPage));
